import Guest from "./guest";
import User from "./user";
import Banners from "./banners";
import News from "./news";
import Slots from "./slots";
import Payments from './payments';
import TableGames from './tableGames';
import Balance from "./balance";
import * as WebsiteData from "./websiteData";
export default {
  Guest,
  User,
  WebsiteData,
  Banners,
  News,
  Slots,
  Payments,
  TableGames,
  Balance
};
